/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setNeuroLocOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getNeuroLoc() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const neuroLocResponse = yield call([vitalsService, vitalsService.getNeuroLoc])
    const { entity } = neuroLocResponse
    yield put(setNeuroLocOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getNeuroLoc() error: ${e}`))
  }
}

export function* getNeuroLocSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getNeuroLoc)
}
